export default function MediaCoverage() {
  const coverage = [
    {
      outlet: 'TechCrunch',
      logo: 'ri-newspaper-line',
      title: 'TrackVerse Disrupts Traditional Logistics with AI-Powered Tracking',
      date: 'March 2024',
      link: '#'
    },
    {
      outlet: 'Forbes',
      logo: 'ri-newspaper-line',
      title: 'How TrackVerse is Making Global Shipping Transparent',
      date: 'February 2024',
      link: '#'
    },
    {
      outlet: 'Bloomberg',
      logo: 'ri-newspaper-line',
      title: 'TrackVerse Founder Michael Ashley on the Future of Logistics',
      date: 'January 2024',
      link: '#'
    },
    {
      outlet: 'The Wall Street Journal',
      logo: 'ri-newspaper-line',
      title: 'Startup TrackVerse Expands to 50 Countries in Record Time',
      date: 'December 2023',
      link: '#'
    },
    {
      outlet: 'Reuters',
      logo: 'ri-newspaper-line',
      title: 'TrackVerse Partners with Major Carriers for Global Expansion',
      date: 'November 2023',
      link: '#'
    },
    {
      outlet: 'Financial Times',
      logo: 'ri-newspaper-line',
      title: 'Sustainable Logistics: TrackVerse Leads Carbon-Neutral Initiative',
      date: 'October 2023',
      link: '#'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Media Coverage
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            TrackVerse in the news
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {coverage.map((item, index) => (
            <a
              key={index}
              href={item.link}
              className="bg-white rounded-lg p-6 border border-gray-200 hover:shadow-lg transition-shadow cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                  <i className={`${item.logo} text-xl text-blue-600`}></i>
                </div>
                <div className="font-bold text-gray-900">{item.outlet}</div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3 leading-snug">
                {item.title}
              </h3>
              <div className="text-sm text-gray-500">{item.date}</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
